export const APP_CDT_SCHEME = 'cartaodetodos://open/payment-link'

export const APP_CDT_OPEN_TIMEOUT_MS = 2500

export const APP_CDT_REDIRECT_STORAGE_PREFIX = 'cdt-app-redirect'
